"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownOption = void 0;
var React = require("react");
var Text_1 = require("../Text");
var DropdownOption_st_css_1 = require("./DropdownOption.st.css");
exports.DropdownOption = function (props) {
    var value = props.value, id = props.id, isSelectable = props.isSelectable, subtitle = props.subtitle, icon = props.icon, isSectionTitle = props.isSectionTitle, className = props.className;
    return (React.createElement("div", { key: id, className: DropdownOption_st_css_1.st(DropdownOption_st_css_1.classes.root, {
            withIcon: !!icon,
            sectionTitle: isSectionTitle,
            selectable: isSelectable,
        }, className) },
        icon && React.createElement("div", { className: DropdownOption_st_css_1.classes.icon }, icon),
        React.createElement("div", { className: DropdownOption_st_css_1.classes.contentWrapper },
            React.createElement(Text_1.Text, { className: DropdownOption_st_css_1.classes.title, typography: Text_1.TYPOGRAPHY.runningText }, value),
            subtitle && (React.createElement(Text_1.Text, { className: DropdownOption_st_css_1.classes.subtitle, typography: Text_1.TYPOGRAPHY.runningText }, subtitle)))));
};
//# sourceMappingURL=DropdownOption.js.map